export const RECEIVE_ARTICLES = 'RECEIVE_ARTICLES';
export const SORT_ARTICLES = 'SORT_ARTICLES';
export const SET_PROJECT_FILTER = 'SET_PROJECT_FILTER';
export const SET_NEWNESS_FILTER = 'SET_NEWNESS_FILTER';
export const SET_TRACKED_STATUS_FILTER = 'SET_TRACKED_STATUS_FILTER';
export const UPDATE_ARTICLE_TRACKED_STATUS = 'UPDATE_ARTICLE_TRACKED_STATUS';
export const SET_ARTICLES_PAGE = 'SET_ARTICLES_PAGE';
export const ARTICLES_PER_PAGE = 100;
export const RESET_PAGES = 'RESET_PAGES';
export const UPDATE_ARTICLE_TITLE_AND_URL = 'UPDATE_ARTICLE_TITLE_AND_URL';
